(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nt-matching-tshirt"] && !Shopify.designMode) return;
  try {
    function setupMatchingTshirts(root = document) {
    root.querySelectorAll('[data-nt-match-card]').forEach((card) => {
      if (card.dataset.matchReady) return;
      card.dataset.matchReady = 'true';
      const form = card.querySelector('form');
      const select = card.querySelector('[data-nt-match-select]');
      const button = card.querySelector('[data-nt-match-add]');
      const price = card.querySelector('[data-nt-match-price]');
      if (!form || !select || !button) return;
      const canSelect = !select.disabled;
      button.disabled = true;
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        button.disabled = !canSelect || !option?.value || option.disabled;
        if (option?.dataset.price && price) price.textContent = option.dataset.price;
      });
      form.addEventListener('submit', (event) => {
        if (typeof addToCart !== 'function') return;
        event.preventDefault();
        if (!button.disabled && select.value) addToCart(select.value, button);
      });
    });
  }
  setupMatchingTshirts();
  document.addEventListener('shopify:section:load', (event) => setupMatchingTshirts(event.target));
  } catch(e) { console.error(e); }
})();

})();
